var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"manualPage"},[(_vm.fileInfo)?_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":_vm.fileInfo.filePath}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }